import {Component, Input, OnInit} from '@angular/core';
import {JP} from "../../helpers/jp";
import {UI_TEXTS} from "../../enums/e-texts";
import {VALUE_TYPE} from "../../enums/enums";
import {FactoryService} from "../../services/factory.service";
import {IQuestRewardTemplate} from "../../definitions";

@Component({
  selector: 'nv-quest-reward-template',
  templateUrl: './nv-quest-reward-template.component.html',
  styles: []
})
export class NvQuestRewardTemplateComponent implements OnInit {

  public UI_TEXTS = UI_TEXTS
  public VALUE_TYPE = VALUE_TYPE;

  public selected:IQuestRewardTemplate;
  private _document: any;
  private _pointer: string;
  private _title: string;

  @Input() set document(v: any) {
    this._document = v;
  };

  @Input() set pointer(v: string) {
    this._pointer = v;
  }

  @Input() set title(v: string) {
    this._title = v;
  }

  get document() { return this._document; }
  get pointer() { return this._pointer; }
  get title() { return this._title || "no title"; }
  get templates():any[]
  {
    return JP.get(this.document, this.pointer);
  }

  constructor(private factoryService:FactoryService) { }

  ngOnInit() {
  }

  onAddClick()
  {
    this.factoryService.gameObjectUtils.addQuestRewardTemplateTo(this.document, this.pointer);
  }

  getItemLabel(template:IQuestRewardTemplate) {
    return `${template.name}`;
  }

  onItemSelected(r:IQuestRewardTemplate) {
    this.selected = r;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-quest-reward-template/nv-quest-reward-template.component.ts